const styles = ({ COLORS }) => ({
  section: {
    borderBottom: 'none'
  },
  limit: {
    float: 'right'
  },
  max: {
    color: COLORS.RED.NORMAL
  },
  desc: {
    justifyContent: 'center'
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    '& label': {
      marginLeft: '10px',
      cursor: 'pointer'
    }
  }
})

export default styles
